<template>
    <div class="mpc-statistics-page">
        <v-container>
            <v-tabs v-model="activeTab" class="selection-tabs" centered height="30">
                <v-tab :to="{ name: 'mpcStatisticsDaily' }" value="daily">Daglig</v-tab>
                <v-tab :to="{ name: 'mpcStatisticsMonthly' }" value="monthly">Månedlig</v-tab>
                <v-tab :to="{ name: 'mpcStatisticsExport' }" value="export">Eksport</v-tab>
            </v-tabs>
            <v-divider />
        </v-container>
        <router-view />
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const activeTab = ref<string>(tabFromRoute(String(route.name)));

watch(
    () => route.name,
    name => (activeTab.value = tabFromRoute(String(name)))
);

function tabFromRoute(name: string): string {
    if (name === 'mpcStatisticsMonthly') return 'monthly';
    if (name === 'mpcStatisticsExport') return 'export';
    return 'daily';
}
</script>

<style scoped>
.selection-tabs .v-tab {
    background: rgba(0, 0, 0, 0.03);
}
.selection-tabs .v-tab--selected,
.selection-tabs .v-tab--active {
    background: rgba(0, 0, 0, 0.06);
}
</style>
